import nfetch from "@/utils/events/nfetch";

class NotaFiscalServicoEmissaoLoteService {
    public list(
        pageIndex: number,
        pageSize: number,
        emissaoDe: string,
        emissaoAte: string,
        dataEntregaDe: string,
        dataEntregaAte: string,
        situacao: number,
        filterKey: string,
        vendedorId: number,
        dataFaturamentoDe: string,
        dataFaturamentoAte: string,
        tipoVendaId: number,
    ) {
        const encodedFilter = encodeURIComponent(filterKey);

        return nfetch(
            `/NotaFiscalServicoEmissaoLote/List?filterKey=${encodedFilter}&pageIndex=${pageIndex}&pageSize=${pageSize}&emissaoDe=${emissaoDe}&emissaoAte=${emissaoAte}&dataEntregaDe=${dataEntregaDe}&dataEntregaAte=${dataEntregaAte}&situacao=${situacao}&vendedorId=${vendedorId}&dataFaturamentoDe=${dataFaturamentoDe}&dataFaturamentoAte=${dataFaturamentoAte}&tipoVendaId=${tipoVendaId}`,
            {
                credentials: "same-origin",
            },
        );
    }

    public emitirEmLoteByVendaIds(vendaIds: Array<number>) {
        return nfetch(`/NotaFiscalServicoEmissaoLote/EmissaoLoteByVendaIds`, {
            method: "post",
            credentials: "same-origin",
            headers: {
                "Content-Type": "application/json; charset=UTF-8",
            },
            body: JSON.stringify(vendaIds),
        });
    }
}

export default new NotaFiscalServicoEmissaoLoteService();
